import { render, staticRenderFns } from "./ActiveBtn.vue?vue&type=template&id=3f283232&scoped=true&lang=pug&"
import script from "./ActiveBtn.vue?vue&type=script&lang=js&"
export * from "./ActiveBtn.vue?vue&type=script&lang=js&"
import style0 from "./ActiveBtn.vue?vue&type=style&index=0&id=3f283232&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f283232",
  null
  
)

export default component.exports